type IdentityEnvironment = 'staging' | 'production';

export type EnvironmentConfig = 'development' | 'staging' | 'production';

export function getEnvironment(): EnvironmentConfig {
  // Use REACT_APP_ENVI env variable to determine the environment.
  const envi = process.env.REACT_APP_ENVI;
  if (envi === 'production') return 'production';
  if (envi === 'staging') return 'staging';
  if (envi === 'development') return 'development';

  return 'development';
}

export function getCommunityUrl(): string {
  return (
    process.env.REACT_APP_COMMUNITY_BASE_URL ??
    'https://community.atlassian.com'
  );
}

export function redirectTo(url: string): void {
  window.location.replace(url);
}

export function getIdentityEnvironment(): IdentityEnvironment {
  const env = getEnvironment();
  if (env === 'development') {
    return 'staging';
  }

  return env as IdentityEnvironment;
}
